export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11883.af2c8926.jpg";